var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiltered(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1979",
    "data-name": "Group 1979",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3181",
    "data-name": "Rectangle 3181",
    width: 28,
    height: 28,
    rx: 5,
    transform: "translate(0 0)",
    fill: "#4EB6EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-filter-3957532",
    transform: "translate(6.403 6.394)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8945",
    "data-name": "Path 8945",
    d: "M105.687,35a.542.542,0,0,0-.462.814l5.892,7.873v5.973a.543.543,0,0,0,.787.489l2.172-1.086a.513.513,0,0,0,.3-.489V43.688l5.892-7.873a.542.542,0,0,0-.462-.814Z",
    transform: "translate(-105.149 -35)",
    fill: "red"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltered);
export default __webpack_public_path__ + "static/media/filtered.fce117bf9f8d3a25bc1d52a28c52d017.svg";
export { ForwardRef as ReactComponent };